import { useState, useEffect, useRef, useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { useCart, clearCart, removeSeat } from '../stores/cartStore';
import { useFavorites } from '../hooks/useFavorites';
import { parseLocalDate } from '../utils/dates';
import AuthModal from './AuthModal';
import './AuthModal.css';
import './Header.css';

// Íconos
const logoWhite = "/logo-blanco.svg";
const searchIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E";
const searchIconDark = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%236d28d9' stroke-width='2.5' stroke-linecap='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E";
const userIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 .391667 6.9 0 8 0C9.1 0 10.0417.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6333.145833 12.1125.4375 11.6375C.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM2 14H14V13.2C14 13.0167 13.9542 12.85 13.8625 12.7C13.7708 12.55 13.65 12.4333 13.5 12.35C12.6 11.9 11.6917 11.5625 10.775 11.3375C9.85833 11.1125 8.93333 11 8 11C7.06667 11 6.14167 11.1125 5.225 11.3375C4.30833 11.5625 3.4 11.9 2.5 12.35C2.35 12.4333 2.22917 12.55 2.1375 12.7C2.04583 12.85 2 13.0167 2 13.2V14ZM8 6C8.55 6 9.02083 5.80417 9.4125 5.4125C9.80417 5.02083 10 4.55 10 4C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4C6 4.55 6.19583 5.02083 6.5875 5.4125C6.97917 5.80417 7.45 6 8 6Z' fill='white'/%3E%3C/svg%3E";
const ticketsIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z'/%3E%3Cpath d='M13 5v2m0 4v2m0 4v2'/%3E%3C/svg%3E";
const categoriesIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M4 6h16M4 12h16M4 18h16'/%3E%3C/svg%3E";
const helpIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3'/%3E%3Cline x1='12' y1='17' x2='12.01' y2='17'/%3E%3C/svg%3E";
const ordersIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E";
const menuIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='18' height='12'%3E%3Cpath d='M128 102.4c0-14.138 11.462-25.6 25.6-25.6h332.8c14.138 0 25.6 11.462 25.6 25.6S500.538 128 486.4 128H153.6c-14.138 0-25.6-11.463-25.6-25.6zm358.4 128H25.6C11.462 230.4 0 241.863 0 256c0 14.138 11.462 25.6 25.6 25.6h460.8c14.138 0 25.6-11.462 25.6-25.6 0-14.137-11.462-25.6-25.6-25.6zm0 153.6H256c-14.137 0-25.6 11.462-25.6 25.6 0 14.137 11.463 25.6 25.6 25.6h230.4c14.138 0 25.6-11.463 25.6-25.6 0-14.138-11.462-25.6-25.6-25.6z' fill='%23ffffff'/%3E%3C/svg%3E";
const closeIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E";
const closeIconDark = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%23494553' stroke-width='2.5' stroke-linecap='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E";
const calendarSmall = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2'%3E%3Crect x='3' y='4' width='18' height='18' rx='2'/%3E%3Cline x1='16' y1='2' x2='16' y2='6'/%3E%3Cline x1='8' y1='2' x2='8' y2='6'/%3E%3Cline x1='3' y1='10' x2='21' y2='10'/%3E%3C/svg%3E";

// El carrito viene del store compartido

function formatFecha(dateStr) {
  if (!dateStr) return '';
  const d = parseLocalDate(dateStr);
  return d.toLocaleDateString('es-CO', { month: 'short', day: 'numeric' });
}

function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}

function SearchResults({ results, loading, query, onClose }) {
  if (!query || query.length < 2) return null;
  return (
    <div className="busqueda-resultados">
      {loading ? (
        <div className="busqueda-resultados__loading">Buscando...</div>
      ) : results.length === 0 ? (
        <div className="busqueda-resultados__vacio">No se encontraron eventos para "{query}"</div>
      ) : (
        results.map(ev => (
          <a key={ev.id} href={`/eventos/${ev.slug}`} className="busqueda-resultado" onClick={onClose}>
            <div className="busqueda-resultado__img">
              {ev.image_url ? (
                <img src={ev.image_url} alt="" />
              ) : (
                <div className="busqueda-resultado__img-placeholder" />
              )}
            </div>
            <div className="busqueda-resultado__info">
              <h4 className="busqueda-resultado__titulo">{ev.title}</h4>
              <div className="busqueda-resultado__meta">
                <img src={calendarSmall} alt="" />
                <span>{formatFecha(ev.starts_at)}</span>
                {ev.venue && <span>• {ev.venue.name}</span>}
              </div>
              {ev.category && <span className="busqueda-resultado__cat">{ev.category.name}</span>}
            </div>
          </a>
        ))
      )}
    </div>
  );
}

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [carritoOpen, setCarritoOpen] = useState(false);
  const [favoritosOpen, setFavoritosOpen] = useState(false);
  const carritoItems = useCart();
  const { favorites, removeFavorite, count: favCount } = useFavorites();
  const [searchOpen, setSearchOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [userPanelOpen, setUserPanelOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('auth_user') || 'null'); } catch { return null; }
  });
  const [lastOrder, setLastOrder] = useState(null);
  const isLoggedIn = !!localStorage.getItem('auth_token');

  // Estado de búsqueda
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedQuery = useDebounce(searchQuery, 200);
  const searchInputRef = useRef(null);
  const mobileSearchRef = useRef(null);
  const searchWrapRef = useRef(null);

  // Obtener resultados de búsqueda
  const { data: searchData, isFetching: searchLoading } = useQuery({
    queryKey: ['headerSearch', debouncedQuery],
    queryFn: async () => {
      const res = await fetch(`/api/buscar?q=${encodeURIComponent(debouncedQuery)}`).then(r => r.json());
      if (res.exito) return res.datos;
      return [];
    },
    enabled: debouncedQuery.length >= 2,
    staleTime: 60000,
  });

  const searchResults = (debouncedQuery.length >= 2) ? (searchData || []) : [];

  // Cerrar resultados de escritorio al hacer clic fuera
  useEffect(() => {
    function handleClick(e) {
      if (searchWrapRef.current && !searchWrapRef.current.contains(e.target)) {
        setSearchQuery('');
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Enfocar el campo de búsqueda móvil cuando se abre el overlay
  useEffect(() => {
    if (searchOpen && mobileSearchRef.current) {
      setTimeout(() => mobileSearchRef.current.focus(), 100);
    }
  }, [searchOpen]);

  const closeSearch = useCallback(() => {
    setSearchQuery('');
    setSearchOpen(false);
  }, []);

  const handleAccountClick = () => {
    if (isLoggedIn && currentUser) {
      setUserPanelOpen(true);
      // Actualizar perfil (foto, datos recientes) y obtener último pedido
      const token = localStorage.getItem('auth_token');
      fetch('/api/auth/profile', { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(data => {
          const user = data.usuario || data.user || data;
          if (user && user.id) {
            localStorage.setItem('auth_user', JSON.stringify(user));
            setCurrentUser(user);
          }
        })
        .catch(() => {});
      fetch('/api/auth/my-orders', { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(data => {
          const orders = data.datos || data.orders || [];
          if (orders.length > 0) setLastOrder(orders[0]);
        })
        .catch(() => {});
    } else {
      setAuthModalOpen(true);
    }
  };

  // Actualizar perfil al montar si el usuario está autenticado
  const { data: profileData } = useQuery({
    queryKey: ['headerProfile'],
    queryFn: async () => {
      const token = localStorage.getItem('auth_token');
      if (!token) throw new Error('No token');
      const r = await fetch('/api/auth/profile', { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error('Profile failed');
      return r.json();
    },
    enabled: isLoggedIn,
    staleTime: 300000,
  });

  useEffect(() => {
    if (profileData) {
      const user = profileData.usuario || profileData.user || profileData;
      if (user && user.id) {
        localStorage.setItem('auth_user', JSON.stringify(user));
        setCurrentUser(user);
      }
    }
  }, [profileData]);

  // Listeners globales para la navegación inferior
  useEffect(() => {
    const onOpenCart = () => setCarritoOpen(true);
    const onOpenFavs = () => setFavoritosOpen(true);
    const onOpenProfile = () => handleAccountClick();

    window.addEventListener('open-cart', onOpenCart);
    window.addEventListener('open-favorites', onOpenFavs);
    window.addEventListener('open-profile', onOpenProfile);

    return () => {
      window.removeEventListener('open-cart', onOpenCart);
      window.removeEventListener('open-favorites', onOpenFavs);
      window.removeEventListener('open-profile', onOpenProfile);
    };
  }, [isLoggedIn, currentUser]);

  const handleAuthSuccess = (user) => {
    setCurrentUser(user);
  };

  const handleLogout = async () => {
    const token = localStorage.getItem('auth_token');
    try {
      if (token) await fetch('/api/auth/logout', { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
    } catch {}
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    setCurrentUser(null);
    setUserPanelOpen(false);
    setLastOrder(null);
  };

  // Cargar datos de eventos favoritos (lazy: solo cuando el panel se abre)
  const favKey = JSON.stringify(favorites);
  const { data: favEventsData } = useQuery({
    queryKey: ['headerFavEvents', favKey],
    queryFn: async () => {
      const res = await fetch('/api/eventos?per_page=100').then(r => r.json());
      if (res.exito) {
        const all = res.datos.data || res.datos || [];
        return all.filter(e => favorites.includes(e.id));
      }
      return [];
    },
    enabled: favoritosOpen && favorites.length > 0,
    staleTime: 60000,
  });
  const favEvents = favEventsData || [];

  return (
    <header className="encabezado">
      {/* Main Navigation */}
      <div className="nav-principal">
        <div className="nav-principal__container">
          <a href="/" className="nav-principal__logo">
            <img src={logoWhite} alt="+eventos" />
          </a>

          {/* Desktop: Search Bar */}
          <div className="barra-busqueda" ref={searchWrapRef}>
            <div className="barra-busqueda__category">
              <span>Todas las categorías</span>
            </div>
            <div className="barra-busqueda__input-wrap">
              <input
                ref={searchInputRef}
                className="barra-busqueda__input"
                type="text"
                placeholder="Busca conciertos, teatro, deportes..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="barra-busqueda__btn" onClick={() => searchInputRef.current?.focus()}>
              <img src={searchIcon} alt="Buscar" />
            </div>
            <SearchResults
              results={searchResults}
              loading={searchLoading}
              query={debouncedQuery}
              onClose={closeSearch}
            />
          </div>

          {/* Desktop: Account Area */}
          <div className="area-cuenta">
            {isLoggedIn && currentUser ? (
              <>
                {currentUser.photo_url ? (
                  <img className="area-cuenta__user-icon" src={currentUser.photo_url}
                    alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(255,255,255,0.4)' }} />
                ) : (
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'rgba(255,255,255,0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', fontWeight: 700, color: '#fff' }}>
                    {currentUser.name?.charAt(0).toUpperCase()}
                  </div>
                )}
                <button className="area-cuenta__link" onClick={handleAccountClick}>
                  <span>{currentUser.name?.split(' ')[0]}</span>
                </button>
              </>
            ) : (
              <>
                <img className="area-cuenta__user-icon" src={userIcon} alt="" />
                <button className="area-cuenta__link" onClick={handleAccountClick}>
                  <span>Mi Cuenta</span>
                </button>
              </>
            )}
            <div className="area-cuenta__tickets" onClick={() => setCarritoOpen(true)} style={{cursor:'pointer'}}>
              <img className="area-cuenta__tickets-icon" src={ticketsIcon} alt="" />
              <span className="area-cuenta__link">Mis Boletos</span>
              {carritoItems.length > 0 && <span className="area-cuenta__badge">{carritoItems.reduce((s,i) => s + (i.cantidad||0), 0)}</span>}
            </div>
          </div>

          {/* Mobile: Icon buttons */}
          <div className="iconos-movil">
            <button className="iconos-movil__btn" aria-label="Buscar" onClick={() => setSearchOpen(true)}>
              <img src={searchIcon} alt="Buscar" />
            </button>
            <button className="iconos-movil__btn" aria-label="Mi cuenta" onClick={handleAccountClick}>
              {isLoggedIn && currentUser?.photo_url ? (
                <img src={currentUser.photo_url} alt="" style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover' }} />
              ) : (
                <img src={userIcon} alt="Mi cuenta" />
              )}
            </button>
            <button className="iconos-movil__btn iconos-movil__btn--carrito" aria-label="Mis boletos" onClick={() => setCarritoOpen(true)}>
              <img src={ticketsIcon} alt="Mis boletos" />
              {carritoItems.length > 0 && <span className="iconos-movil__badge">{carritoItems.reduce((s,i) => s + (i.cantidad||0), 0)}</span>}
            </button>
            <button className="iconos-movil__btn" aria-label="Menú" onClick={() => setMenuOpen(true)}>
              <img src={menuIcon} alt="Menú" />
            </button>
          </div>
        </div>
      </div>

      {/* Secondary Navigation (desktop only) */}
      <div className="nav-secundaria">
        <div className="nav-secundaria__container">
          <nav className="nav-secundaria__links">
            <Link to="/eventos" className="nav-secundaria__link secondary-nav__link--bold">
              <img src={categoriesIcon} alt="" width="13.5" height="9" />
              Categorías
            </Link>
            <Link to="/categoria/conciertos" className="nav-secundaria__link">Conciertos</Link>
            <Link to="/categoria/teatro" className="nav-secundaria__link">Teatro</Link>
            <Link to="/categoria/deportes" className="nav-secundaria__link">Deportes</Link>
            <Link to="/categoria/festivales" className="nav-secundaria__link">Festivales</Link>
            <Link to="/categoria/comedia" className="nav-secundaria__link">Comedia</Link>
            <Link to="/categoria/talleres" className="nav-secundaria__link">Talleres</Link>
          </nav>
          <div className="nav-secundaria__right">
            <Link to="/ayuda" className="nav-secundaria__right-link">
              <img src={helpIcon} alt="" width="15" height="15" />
              Centro de Ayuda
            </Link>
            <a href="#" className="nav-secundaria__right-link" onClick={e => { e.preventDefault(); setFavoritosOpen(true); }}>
              <img src={ordersIcon} alt="" width="16.5" height="12" />
              Mis Favoritos
              {favCount > 0 && <span className="nav-secundaria__badge">{favCount}</span>}
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Search Overlay */}
      <div className={`busqueda-movil ${searchOpen ? 'busqueda-movil--abierto' : ''}`}>
        <div className="busqueda-movil__cabecera">
          <div className="busqueda-movil__input-wrap">
            <img src={searchIconDark} alt="" className="busqueda-movil__icono" />
            <input
              ref={mobileSearchRef}
              className="busqueda-movil__input"
              type="text"
              placeholder="Buscar eventos..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>
          <button className="busqueda-movil__cerrar" onClick={closeSearch}>
            <img src={closeIconDark} alt="Cerrar" />
          </button>
        </div>
        <div className="busqueda-movil__resultados">
          <SearchResults
            results={searchResults}
            loading={searchLoading}
            query={debouncedQuery}
            onClose={closeSearch}
          />
        </div>
      </div>

      {/* Off-Canvas: Menu */}
      <div className={`offcanvas ${menuOpen ? 'offcanvas--abierto' : ''}`}>
        <div className="offcanvas__overlay" onClick={() => setMenuOpen(false)} />
        <div className="offcanvas__panel">
          <div className="offcanvas__cabecera">
            <img src={logoWhite} alt="+eventos" className="offcanvas__logo" />
            <button className="offcanvas__cerrar" onClick={() => setMenuOpen(false)} aria-label="Cerrar">
              <img src={closeIcon} alt="" />
            </button>
          </div>
          <nav className="offcanvas__nav">
            <span className="offcanvas__seccion-titulo">Categorías</span>
            <Link to="/categoria/conciertos" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Conciertos</Link>
            <Link to="/categoria/teatro" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Teatro</Link>
            <Link to="/categoria/deportes" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Deportes</Link>
            <Link to="/categoria/festivales" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Festivales</Link>
            <Link to="/categoria/comedia" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Comedia</Link>
            <Link to="/categoria/talleres" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Talleres</Link>
          </nav>
          <div className="offcanvas__separador" />
          <nav className="offcanvas__nav">
            <Link to="/ayuda" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Centro de Ayuda</Link>
            <a href="#" className="offcanvas__enlace" onClick={() => { setMenuOpen(false); setFavoritosOpen(true); }}>Mis Favoritos{favCount > 0 ? ` (${favCount})` : ''}</a>
          </nav>
          <div className="offcanvas__pie">
            <button className="boton-principal offcanvas__cta" onClick={() => setMenuOpen(false)}>Explorar Eventos</button>
          </div>
        </div>
      </div>

      {/* Off-Canvas: Carrito / Tickets */}
      <div className={`offcanvas offcanvas--derecha ${carritoOpen ? 'offcanvas--abierto' : ''}`}>
        <div className="offcanvas__overlay" onClick={() => setCarritoOpen(false)} />
        <div className="offcanvas__panel">
          <div className="offcanvas__cabecera">
            <h3 className="offcanvas__titulo">Mis Boletos</h3>
            <button className="offcanvas__cerrar" onClick={() => setCarritoOpen(false)} aria-label="Cerrar">
              <img src={closeIcon} alt="" />
            </button>
          </div>
          {carritoItems.length === 0 ? (
            <div className="carrito__vacio">
              <p>No tienes boletos aún</p>
              <button className="boton-principal" onClick={() => setCarritoOpen(false)}>Explorar Eventos</button>
            </div>
          ) : (
            <>
              <div className="carrito__lista">
                {carritoItems.map(item => (
                  <div key={item.id} className="carrito__item">
                    <div className="carrito__item-info">
                      <h4 className="carrito__item-titulo">{item.evento}</h4>
                      <p className="carrito__item-fecha">{formatFecha(item.fecha)}</p>
                      <div className="carrito__item-meta">
                        <span className="carrito__item-cantidad">{item.cantidad} {item.cantidad > 1 ? 'entradas' : 'entrada'}</span>
                        <span className="carrito__item-precio">${item.total?.toLocaleString('es-CO')} COP</span>
                      </div>
                      {item.seats && (
                        <div className="carrito__item-seats" style={{ marginTop: 6, fontSize: '0.75rem', color: '#7a7585' }}>
                          {item.seats.map((s, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0' }}>
                              <span>{s.label} <span style={{ color: '#3e0f9e', fontWeight: 600 }}>· {s.zone}</span> <span style={{ color: '#494553', fontWeight: 500 }}>· ${Number(s.price).toLocaleString('es-CO')}</span>
                                {item.mostrarServicio && Number(s.serviceFee) > 0 && Number(s.serviceFee) < Number(s.price) && (
                                  <span style={{ color: '#9ca3af', fontSize: '0.68rem' }}> (${(Number(s.price) - Number(s.serviceFee)).toLocaleString('es-CO')} + serv. ${Number(s.serviceFee).toLocaleString('es-CO')})</span>
                                )}
                              </span>
                              <button
                                onClick={(e) => { e.stopPropagation(); removeSeat(s.id); }}
                                aria-label="Eliminar boleto"
                                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: '#dc2626', fontSize: '0.8rem', lineHeight: 1, flexShrink: 0 }}
                                title="Eliminar este boleto"
                              >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <button className="carrito__item-eliminar" aria-label="Eliminar" onClick={() => clearCart()}>✕</button>
                  </div>
                ))}
              </div>
              {(() => {
                const total = carritoItems.reduce((s, i) => s + (i.total || 0), 0);
                const servicio = carritoItems.reduce((s, i) => s + (i.mostrarServicio ? (i.serviceFee || 0) : 0), 0);
                const mostrar = servicio > 0 && servicio < total;
                return (
                  <>
                    {mostrar && (
                      <div className="carrito__total" style={{ fontSize: '0.8rem', color: '#7a7585', paddingBottom: 0 }}>
                        <span>Boletos ${(total - servicio).toLocaleString('es-CO')} · Servicio ${servicio.toLocaleString('es-CO')}</span>
                      </div>
                    )}
                    <div className="carrito__total">
                      <span>Total</span>
                      <strong>${total.toLocaleString('es-CO')} COP</strong>
                    </div>
                  </>
                );
              })()}
              <div className="offcanvas__pie">
                {carritoItems.some(i => i.blocked) && (
                  <p style={{ color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 12, padding: '10px 14px', fontSize: 13, fontWeight: 600, lineHeight: 1.45, margin: '0 0 12px' }}>
                    Tu selección dejaría una silla sola. Ajusta tus asientos en el mapa antes de continuar.
                  </p>
                )}
                <button className="boton-principal offcanvas__cta"
                  disabled={carritoItems.some(i => i.blocked)}
                  onClick={() => {
                  if (carritoItems.some(i => i.blocked)) return;
                  setCarritoOpen(false);
                  const firstItem = carritoItems[0];
                  if (!firstItem) return;
                  // Intentar slug del carrito; si no, usar la ruta actual
                  let slug = firstItem.slug;
                  if (!slug) {
                    const match = window.location.pathname.match(/\/eventos\/([^/]+)/);
                    if (match) slug = match[1];
                  }
                  if (slug) window.location.href = `/checkout/${slug}`;
                }}>Finalizar Compra</button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Off-Canvas: Favoritos */}
      <div className={`offcanvas offcanvas--derecha ${favoritosOpen ? 'offcanvas--abierto' : ''}`}>
        <div className="offcanvas__overlay" onClick={() => setFavoritosOpen(false)} />
        <div className="offcanvas__panel">
          <div className="offcanvas__cabecera">
            <h3 className="offcanvas__titulo">Mis Favoritos</h3>
            <button className="offcanvas__cerrar" onClick={() => setFavoritosOpen(false)} aria-label="Cerrar">
              <img src={closeIcon} alt="" />
            </button>
          </div>
          {favEvents.length === 0 ? (
            <div className="carrito__vacio">
              <p>No tienes favoritos aún</p>
              <button className="boton-principal" onClick={() => setFavoritosOpen(false)}>Explorar Eventos</button>
            </div>
          ) : (
            <div className="carrito__lista">
              {favEvents.map(ev => (
                <div key={ev.id} className="carrito__item">
                  {ev.image_url && (
                    <img
                      src={ev.image_url}
                      alt=""
                      style={{ width: 56, height: 56, borderRadius: '0 12px 0 12px', objectFit: 'cover', flexShrink: 0 }}
                    />
                  )}
                  <div className="carrito__item-info" style={{ flex: 1 }}>
                    <a href={`/eventos/${ev.slug}`} onClick={() => setFavoritosOpen(false)}>
                      <h4 className="carrito__item-titulo">{ev.title}</h4>
                    </a>
                    <p className="carrito__item-fecha">
                      {ev.starts_at ? parseLocalDate(ev.starts_at).toLocaleDateString('es-CO', { day: 'numeric', month: 'short' }) : ''}
                      {ev.venue?.city ? ` • ${ev.venue.city}` : ''}
                    </p>
                  </div>
                  <button className="carrito__item-eliminar" aria-label="Eliminar" onClick={() => removeFavorite(ev.id)}>✕</button>
                </div>
              ))}
            </div>
          )}
          <div className="offcanvas__pie">
            <button className="boton-principal offcanvas__cta" onClick={() => setFavoritosOpen(false)}>Seguir Explorando</button>
          </div>
        </div>
      </div>

      {/* Auth Modal */}
      <AuthModal isOpen={authModalOpen} onClose={() => setAuthModalOpen(false)} onAuth={handleAuthSuccess} />

      {/* Off-Canvas: User Panel */}
      <div className={`offcanvas offcanvas--derecha ${userPanelOpen ? 'offcanvas--abierto' : ''}`}>
        <div className="offcanvas__overlay" onClick={() => setUserPanelOpen(false)} />
        <div className="offcanvas__panel">
          <div className="offcanvas__cabecera">
            <h3 className="offcanvas__titulo">Mi Cuenta</h3>
            <button className="offcanvas__cerrar" onClick={() => setUserPanelOpen(false)} aria-label="Cerrar">
              <img src={closeIcon} alt="" />
            </button>
          </div>

          {currentUser && (
            <>
              <div className="user-offcanvas__header">
                {currentUser.photo_url ? (
                  <img className="user-offcanvas__avatar" src={currentUser.photo_url} alt="" />
                ) : (
                  <div className="user-offcanvas__avatar--initials">
                    {currentUser.name?.charAt(0).toUpperCase()}
                  </div>
                )}
                <div>
                  <p className="user-offcanvas__name">{currentUser.name}</p>
                  <p className="user-offcanvas__email">{currentUser.email}</p>
                </div>
              </div>

              <nav className="user-offcanvas__nav">
                <a href="/mi-cuenta" className="user-offcanvas__link" onClick={() => setUserPanelOpen(false)}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                  </svg>
                  Mi Perfil
                </a>
                <a href="/mi-cuenta" className="user-offcanvas__link" onClick={() => setUserPanelOpen(false)}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="M9 5H2v14h7M9 5l6 7-6 7"/><path d="M15 12H2"/>
                  </svg>
                  Mis Órdenes
                </a>
                <a href="/mi-cuenta" className="user-offcanvas__link" onClick={() => { setUserPanelOpen(false); setFavoritosOpen(true); }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                  </svg>
                  Mis Favoritos
                  {favCount > 0 && <span style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.12)', padding: '2px 8px', borderRadius: 10, fontSize: '0.75rem' }}>{favCount}</span>}
                </a>
              </nav>

              {lastOrder && (
                <div className="user-offcanvas__order">
                  <p className="user-offcanvas__order-title">Último pedido</p>
                  <p className="user-offcanvas__order-event">
                    {lastOrder.items?.[0]?.event?.title || lastOrder.event_title || 'Pedido #' + lastOrder.id}
                  </p>
                  <p className="user-offcanvas__order-date">
                    {lastOrder.created_at ? new Date(lastOrder.created_at).toLocaleDateString('es-CO', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}
                  </p>
                  <span className={`user-offcanvas__order-status user-offcanvas__order-status--${lastOrder.status === 'paid' ? 'paid' : 'pending'}`}>
                    {lastOrder.status === 'paid' ? 'Pagado' : lastOrder.status === 'pending' ? 'Pendiente' : lastOrder.status}
                  </span>
                </div>
              )}

              <div style={{ marginTop: 12 }}>
                <button className="user-offcanvas__logout" onClick={handleLogout}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  Cerrar Sesión
                </button>
              </div>

              <div className="offcanvas__pie">
                <a href="/mi-cuenta" className="boton-principal offcanvas__cta" onClick={() => setUserPanelOpen(false)}
                  style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>Ver Perfil Completo</a>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
